import React from 'react';
import { useTheme } from '../context/ThemeContext';
import { Phone, ArrowRight } from 'lucide-react';

const CTA = () => {
  const { theme } = useTheme();

  const scrollToContact = () => {
    const element = document.querySelector('#hero');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="py-20 md:py-28 bg-gradient-to-r from-[#ff5218] to-[#e54a15]"
      data-testid="cta-section"
    >
      <div className={theme.layout.container}>
        <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
          {/* Content */}
          <div className="text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-2 mb-4 bg-white/20 text-white">
              <span className="w-2 h-2 bg-white rounded-full animate-pulse"></span>
              <span className="text-sm font-medium uppercase tracking-wider">Limited Time Offer</span>
            </div>
            <h2 className={`
              ${theme.typography.headingFont} ${theme.typography.headingWeight}
              text-white text-3xl md:text-4xl lg:text-5xl mb-4 uppercase
            `}>
              Make Your Roof New Again
            </h2>
            <p className="text-white/90 text-lg md:text-xl">
              <span className="font-bold text-2xl md:text-3xl">35% OFF</span> - Spring Special Offer Only This Month
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={scrollToContact}
              className="flex items-center justify-center gap-2 font-bold px-8 py-4 bg-white text-[#ff5218] hover:bg-slate-100 uppercase tracking-wider transition-all duration-300"
            >
              <span>Get Free Quote</span>
              <ArrowRight className="w-5 h-5" />
            </button>
            <a
              href="tel:1300304599"
              className="flex items-center justify-center gap-2 font-bold px-8 py-4 border-2 border-white text-white hover:bg-white hover:text-[#ff5218] uppercase tracking-wider transition-all duration-300"
            >
              <Phone className="w-5 h-5" />
              <span>1300 304 599</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
